import { pick } from 'lodash';
import { Path, SystemLocale } from '@ninja/utilities';
import { addMinutes, getNow, isAfter } from '@ninja/utilities/dist/DateUtils';
import {
	APIFactoryOptions,
	CustomerWebSiteAppInitResponse,
	getAppInitAPI,
} from '@shory-health-individual/customer-api';

type AppInitData = {
	en?: { data: CustomerWebSiteAppInitResponse; expiry: Date };
	ar?: { data: CustomerWebSiteAppInitResponse; expiry: Date };
};

const appInitInfo: AppInitData = {
	en: undefined,
	ar: undefined,
};

export const refreshAppInitServerData = async (serverDataConnection: APIFactoryOptions) => {
	const locale = serverDataConnection.locale ?? 'en';
	const appInitLocalized = appInitInfo[locale];

	if (appInitLocalized && isAfter(appInitLocalized.expiry, getNow())) {
		return;
	}

	const appInit = await getAppInitAPI(serverDataConnection)();

	appInitInfo[locale] = { data: appInit, expiry: addMinutes(getNow(), 5) };
};

export const getAppInitServerData = (
	locale: SystemLocale,
	propsPath?: Path<CustomerWebSiteAppInitResponse>[]
): CustomerWebSiteAppInitResponse => {
	const appInitLocalized = appInitInfo[locale];

	if (!appInitLocalized) {
		throw new Error('Server app/init not initialized');
	}

	if (!propsPath?.length) {
		return appInitLocalized.data;
	}

	return pick(appInitLocalized.data, propsPath);
};
